export default {
  supportedLngs: ["en", "es", "pt", "vi"],
  fallbackLng: "en",
  defaultNS: "default",
  ns: ["default", "zod", "help"],
  react: { useSuspense: false },
};
